import { Row, Col, Button } from 'react-bootstrap';

interface PageHeaderProps {
  title: string;
  onCreateNew: () => void;
}

export const PageHeader = ({ title, onCreateNew }: PageHeaderProps) => {
  return (
    <Row className="mb-4 align-items-center">
      <Col>
        <h2 className="mb-0">{title}</h2>
      </Col>
      <Col xs="auto">
        <Button variant="primary" onClick={onCreateNew}>
          Create New Manual
        </Button>
      </Col>
    </Row>
  );
};
